export const loginUrl = (): string => "/login";

export const financingRequestsUrl = (): string => "/financing-requests";
export const financingRequestNewUrl = (): string => "/financing-requests/new";
export const financingRequestEditUrl = (id?: string): string =>
  `/financing-requests/${id ? id : ":id"}/edit`;
export const financingRequestDetailsUrl = (id?: string): string =>
  `/financing-requests/${id ? id : ":id"}/details`;
export const financingRequestPrintUrl = (id?: string): string =>
  `/financing-requests/${id ? id : ":id"}/print`;
export const financingRequestValidityRangeEditUrl = (id?: string): string =>
  `/financing-requests/${id ? id : ":id"}/validity-range-edit`;

export const paymentRequestsUrl = (): string => "/payment-requests";
export const paymentRequestNewUrl = (): string => "/payment-requests/new";
export const paymentRequestEditUrl = (id?: string): string =>
  `/payment-requests/${id ? id : ":id"}/edit`;
export const paymentRequestDetailsUrl = (id?: string): string =>
  `/payment-requests/${id ? id : ":id"}/details`;
export const paymentRequestPrintUrl = (id?: string): string =>
  `/payment-requests/${id ? id : ":id"}/print`;

export const adminAnnualAdministrationsUrl = (): string =>
  "/admin/annual-administrations";

export const adminFinancingRequestsUrl = (): string =>
  "/admin/financing-requests";
export const adminFinancingRequestDetailsUrl = (id?: string): string =>
  `/admin/financing-requests/${id ? id : ":id"}/details`;

export const adminPaymentRequestsUrl = (): string => "/admin/payment-requests";
export const adminPaymentRequestDetailsUrl = (id?: string): string =>
  `/admin/payment-requests/${id ? id : ":id"}/details`;

export const adminPaymentsUrl = (): string => "/admin/payments";

export const manualsUrl = (): string =>
  "/documents/manuals/eTUR sustav - korisničke upute.pdf";
